import React from 'react';

const EmptyWorkflow = () => {
  const handleAddInputNode = () => {
    window.dispatchEvent(new CustomEvent('add-node-to-workflow', {
      detail: {
        nodeType: 'input',
        nodeData: { label: 'Input', inputType: 'text' }
      }
    }));
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: 420,
      width: '100%',
      // background: 'linear-gradient(135deg, #eff0f4 0%,rgb(240, 242, 252) 100%)',
      padding: 20,
    }}>
      <div style={{
        borderRadius: 24,
        padding: '48px 36px 36px 36px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}>
        <div style={{
          width: 110,
          height: 110,
          background: 'linear-gradient(135deg, #e0e7ff 0%, #f1f5f9 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 18,
          boxShadow: '0 2px 12px rgba(80, 112, 255, 0.08)',
          animation: 'floatPulse 2.2s infinite',
        }}>
          <i className="fa-solid fa-sitemap" style={{ fontSize: 54, color: '#6366f1', filter: 'drop-shadow(0 2px 8px #6366f133)' }}></i>
        </div>
        <h3 style={{
          margin: 0,
          fontSize: 28,
          fontWeight: 700,
          color: '#2d3748',
          letterSpacing: '-0.5px',
        }}>Start building your workflow</h3>
        <p style={{
          marginTop: 15,
          fontSize: 14,
          color: '#64748b',
          textAlign: "center",
          maxWidth: 550,
          fontWeight: 500,
        }}>
          Your workflow is ready to be built. Begin with an input node, then connect agents, tools, and an output to automate your process seamlessly.
        </p>
        <button 
          onClick={handleAddInputNode}
          className="btn btn-primary"
          style={{
            marginTop: 20,
            padding: '6px 25px',
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 12,
            boxShadow: '0 2px 12px rgba(99,102,241,0.10)',
            background: 'linear-gradient(90deg, #6366f1 0%, #60a5fa 100%)',
            border: 'none',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            transition: 'all 0.18s cubic-bezier(.4,0,.2,1)',
            cursor: 'pointer',
          }}
          onMouseOver={e => {
            e.currentTarget.style.background = 'linear-gradient(90deg, #4f46e5 0%, #2563eb 100%)';
            e.currentTarget.style.transform = 'translateY(-2px) scale(1.04)';
            e.currentTarget.style.boxShadow = '0 4px 18px rgba(99,102,241,0.18)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.background = 'linear-gradient(90deg, #6366f1 0%, #60a5fa 100%)';
            e.currentTarget.style.transform = 'none';
            e.currentTarget.style.boxShadow = '0 2px 12px rgba(99,102,241,0.10)';
          }}
        >
          <i className="fa-solid fa-plus" style={{ fontSize: 18 }}></i>
          Start Workflow
        </button>
        <style>{`
          @keyframes floatPulse {
            0% { transform: translateY(0) scale(1); box-shadow: 0 2px 12px rgba(80, 112, 255, 0.08); }
            50% { transform: translateY(-10px) scale(1.06); box-shadow: 0 8px 24px rgba(80, 112, 255, 0.13); }
            100% { transform: translateY(0) scale(1); box-shadow: 0 2px 12px rgba(80, 112, 255, 0.08); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default EmptyWorkflow; 